import React, { FC } from 'react';
import MuiButton, { ButtonProps as MuiButtonProps } from '@mui/material/Button';
import MuiTooltip from '@mui/material/Tooltip';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

export type ButtonVariantType = 'text' | 'outlined' | 'contained';

export interface ButtonProps extends MuiButtonProps {
    tooltiop?: string;
    tooltip?: string;
    mobileFullWidht?: boolean;
    noBackground?: boolean;
}

const Button: FC<ButtonProps> = (props: ButtonProps) => {
    const { variant, tooltiop, tooltip, type, fullWidth, size, noBackground } = props;
    const theme = useTheme();
    const mobile = useMediaQuery(theme.breakpoints.down('sm'));
    const tooltipTitle = tooltip ?? tooltiop;

    const buttonProps = { ...props };
    delete buttonProps.tooltiop;
    delete buttonProps.tooltip;
    delete buttonProps.mobileFullWidht;
    delete buttonProps.noBackground;

    const componentRender = (
        <MuiButton
            {...buttonProps}
            variant={variant || 'contained'}
            type={type || 'button'}
            fullWidth={fullWidth || (mobile && !!props.mobileFullWidht)}
            size={size || 'medium'}
            sx={{
                ...props.sx,
                ...(noBackground
                    ? {
                          '&:hover': {
                              backgroundColor: 'inherit',
                          },
                      }
                    : {}),
            }}
        />
    );
    if (tooltipTitle) {
        return <MuiTooltip title={tooltipTitle}>{componentRender}</MuiTooltip>;
    }

    return componentRender;
};

export default Button;
